export default {
  sidebar: {
    config: 'Config',
    templates: 'Templates',
  },
};
